export const upload = () => (
  <path
    d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4m14-7l-5-5m0 0L7 8m5-5v12"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
